Object.defineProperty(exports, "__esModule", { value: true });
exports.getSizeTokens = void 0;
var getSizeTokens = function (theme) { return theme.sizes; };
exports.getSizeTokens = getSizeTokens;
exports.default = exports.getSizeTokens;
//# sourceMappingURL=getSizeTokens.js.map